module.exports = __webpack_public_path__ + "img/sg.4ebd9325.svg";